import type { Step } from 'react-joyride';

import { ContentTour, TitleTour } from '@cobliteam/onboarding';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const commonConfig = {
  spotlightPadding: 10,
  disableBeacon: true,
  styles: {
    spotlight: {
      border: `2px solid ${colors.primary.default}`,
      borderRadius: '10px',
    },
  },
};

const steps: Step[] = [
  {
    ...commonConfig,
    target: '#addDriverButton',
    placement: 'left',
    title: (
      <TitleTour
        title='Comece adicionando um motorista'
        description='Por aqui, você consegue adicionar motoristas um por um de forma manual, preenchendo as informações necessárias para adicionarmos na sua base.'
      />
    ),
    content: <ContentTour />,
  },
];

export default steps;
